import React from 'react';
import PageHeader from './global-components/page-header';
import Author from './section-components/author';

const AuthorPage = () => {
    return <div>
        <PageHeader headertitle="Author"  />
        <Author />
    </div>
}

export default AuthorPage

